// extracted by mini-css-extract-plugin
module.exports = {"wave":"skeleton_wave__137JF"};